import { CSSProperties } from 'react';
import { ManualTask } from '../../../types/sharedTypeImpl.ts';
import { formatDatetime } from '../../../utils/fieldFormats.ts';


interface Props {
    style?: CSSProperties
    tasks: ManualTask[]
    useLargeFont?: boolean
    showCreatedBy?: boolean
    showCreatedAt?: boolean
    showActivatedAt?: boolean
    showScheduledAt?: boolean
    showClosedAt?: boolean
    showClosedStatus?: boolean
    showClosedBy?: boolean
    showButtons?: boolean
    onEditTaskClick?: (task: ManualTask) => void
    onCancelTaskClick?: (task: ManualTask) => void
    onCompleteTaskClick?: (task: ManualTask) => void
}

export function ManualTasksTable({
    style,
    tasks,
    useLargeFont,
    showCreatedBy,
    showCreatedAt,
    showActivatedAt,
    showScheduledAt,
    showClosedAt,
    showClosedStatus,
    showClosedBy,
    showButtons,
    onEditTaskClick,
    onCancelTaskClick,
    onCompleteTaskClick,
}: Props) {
    function getCreatedByWithEdit(task: ManualTask) {
        const lastEditedBy = task.edits?.at(-1)?.editedBy;
        const showEditor = lastEditedBy && lastEditedBy !== task.createdBy;
        const combined = showEditor ? `${task.createdBy}, ${lastEditedBy}` : task.createdBy;
        return combined;
    }

    return (
        <table style={style ?? {}}>
            <thead>
                <tr>
                    <th>Task</th>
                    {showCreatedBy && <th style={{ width: '100px' }}>Created by</th>}
                    {showCreatedAt && <th style={{ width: '150px' }}>Created at</th>}
                    {showActivatedAt && <th style={{ width: '150px' }}>Activated at</th>}
                    {showScheduledAt && <th style={{ width: '150px' }}>Scheduled at</th>}
                    {showClosedAt && <th style={{ width: '150px' }}>Closed at</th>}
                    {showClosedStatus && <th style={{ width: '120px' }}>Status</th>}
                    {showClosedBy && <th style={{ width: '120px' }}>Closed by</th>}
                    {showButtons && <th style={{ width: '128px' }} />}
                </tr>
            </thead>
            <tbody>
                {tasks?.map((task) => (
                    <tr key={task._id} style={{ margin: '8px 8px' }}>
                        <td className={useLargeFont ? 'tasks--medium-text' : ''}>{task.text}</td>
                        {showCreatedBy && <td>{getCreatedByWithEdit(task)}</td>}
                        {showCreatedAt && <td>{formatDatetime(task.createdAt)}</td>}
                        {showActivatedAt && <td>{formatDatetime(task.scheduledAt)}</td>}
                        {showScheduledAt && <td>{formatDatetime(task.scheduledAt)}</td>}
                        {showClosedAt && <td>{formatDatetime(task.closedAt)}</td>}
                        {showClosedStatus && <td>{task.isCompleted ? 'Completed' : task.isCanceled ? 'Canceled' : ''}</td>}
                        {showClosedBy && <td>{task.closedBy}</td>}
                        {showButtons && (
                            <td>
                                <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                    <button
                                        style={{ width: '36px' }}
                                        onClick={() => onEditTaskClick?.(task)}
                                        className='text-muted-foreground'
                                        children='✎'
                                    />
                                    <button
                                        style={{ width: '36px' }}
                                        onClick={() => onCancelTaskClick?.(task)}
                                        className='text-muted-foreground'
                                        children='✖'
                                    />
                                    <button
                                        style={{ width: '36px' }}
                                        onClick={() => onCompleteTaskClick?.(task)}
                                        className='text-muted-foreground'
                                        children='✓'
                                    />
                                </div>
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
